import PropTypes from 'prop-types';
import SidebarAdmin from '../Admin/Sidebar/SidebarAdmin';
import Avatar from '../../pages/Profile/Avatar';
import useAuthContext from '../../hooks/useAuthContext';
import Notification from '../Notification/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ADMIN_HOME,
  ADMIN_LINK,
  ADMIN_PERSONALIZE,
  ADMIN_PRODUCTS,
  ADMIN_SETTING,
  ADMIN_USERS,
  PROFILE,
} from '../../routes/app/paths';
import { getAvatar } from '../../utils/common';
import DashboardBackground from '../../assets/images/DashboardBackground.webp';

const headerConf = {
  [ADMIN_HOME]: {
    title: 'Dashboard',
    welcome: true,
  },
  [ADMIN_PRODUCTS]: {
    title: 'Productos',
  },
  [ADMIN_USERS]: {
    title: 'Usuarios',
  },
  [ADMIN_LINK]: {
    title: 'Links de pago',
  },
  [ADMIN_SETTING]: {
    title: 'Configuración',
  },
  [ADMIN_PERSONALIZE]: {
    title: 'Personalizar',
  },
};

const HeaderAdmin = () => {
  const { user } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const { title, welcome } = headerConf[location.pathname] || { title: '', welcome: false };

  return (
    <div className="flex justify-between items-center select-none">
      {/* Welcome */}
      <div className="flex flex-col">
        {welcome && (
          <span className="text-gray-500 text-lg">{`¡Hola ${user.name}! 👋`}</span>
        )}
        <span className="text-4xl text-black font-semibold truncate py-1">
          {title}
        </span>
      </div>

      {/* User area */}
      <div className="flex gap-3 items-center">
        <Notification />
        <div className="h-12 w-[1px]" />
        <div onClick={() => navigate(PROFILE)} className="flex gap-3 justify-center items-center p-2 rounded-full cursor-pointer hover:shadow-md active:opacity-80">
          <Avatar
            src={getAvatar(user?.avatar)}
            alt={user?.name}
            size="w-12 h-12"
            className="rounded-full text-green-dark  pointer-events-none"
          />
          <div className="flex flex-col justify-center truncate">
            <span className="text-xl font-semibold ">
              {user.name} {user.last_name}
            </span>
            <span className="text-base text-gray-500">Administrador</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminLayout = ({ children }) => {
  return (
    <div className="flex gap-4 w-screen h-screen"
      style={{
        backgroundImage: `url(${DashboardBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      <SidebarAdmin />

      <div className="flex flex-col gap-8 flex-1 mt-8 rounded-tl-2xl overflow-hidden p-5 px-7">
        <HeaderAdmin />
        <div className="flex-1 min-h-0 overflow-auto">{children}</div>
      </div>
    </div>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminLayout;
